
<template>
    <div class="page">
         <div class="header">后台管理</div>

        <a-tabs v-model="activeTab">

        <a-tab-pane key="stats" tab="统计">

            <a-skeleton v-if="statsLoading" />

            <div v-else>
                <div class="item" v-for="group in joinList" :key="group.type">
                    <div class="title">
                        <span>{{ group.label }}</span>
                        <span class="count">共 {{ group.list.length }} 人</span>
                    </div>

                    <a-table
                        :data-source="group.list"
                        :columns="statsColumns"
                        :pagination="false"
                        :row-key="(record, index) => index"
                        size="small" />
                </div>

                <a-empty v-if="joinList.length === 0" />
            </div>

        </a-tab-pane>

        <a-tab-pane key="config" tab="设置">

         <a-skeleton v-if="loading" />

        <div v-else>

            <div class="list">
            <div class="item" v-for="(item, index) in list" :key="index">

                <div class="title">
                    <span>{{ item.label || '未命名活动' }}</span>
                    <a-popconfirm title="确认删除该活动？" @confirm="removeActivity(index)">
                        <a-button type="danger" size="small" ghost>删除活动</a-button>
                    </a-popconfirm>
                </div>

                <div class="section">
                    <div class="label">开启活动</div>
                    <a-switch v-model="item.open" />
                </div>

                <div class="field">
                    <div class="label">活动名称</div>
                    <a-input v-model="item.label" placeholder="如：深企行 - 8月2日企业参访" />
                </div>

                <div class="field">
                    <div class="label">类型标识（type）</div>
                    <a-input v-model="item.type" placeholder="如：class1" />
                </div>

                <div class="label options-label">选项</div>

                <div v-if="Array.isArray(item.options)">
                    <div class="option-card" v-for="(option, oIndex) in item.options" :key="oIndex">
                        <div class="option-header">
                            <span class="option-index">选项 {{ oIndex + 1 }}</span>
                            <a-popconfirm title="确认删除该选项？" @confirm="removeOption(item, oIndex)">
                                <a-button type="danger" size="small" ghost icon="delete" />
                            </a-popconfirm>
                        </div>

                        <div class="field">
                            <div class="label">标题</div>
                            <a-input v-model="option.label" placeholder="如：高巨创新和深能环保" />
                        </div>

                        <div class="field">
                            <div class="label">描述</div>
                            <a-textarea v-model="option.desc" :auto-size="{ minRows: 2 }" placeholder="选项介绍" />
                        </div>

                        <div class="field row">
                            <div class="label">最大人数</div>
                            <a-input-number v-model="option.max" :min="1" />
                        </div>
                    </div>
                </div>

                <a-button type="dashed" block icon="plus" @click="addOption(item)">添加选项</a-button>
            </div>
         </div>

         <a-button type="dashed" block icon="plus" class="add-activity" @click="addActivity">添加活动</a-button>

         <a-button type="primary" block @click="submit" size="large" :loading="saving">提交</a-button>

        </div>

        </a-tab-pane>

        </a-tabs>

    </div>
</template>


<script>
    import { fetchConfig,setConfig,fetchJoinList } from '../../api/sign-up';
    export default {

        data() {
            return {
                activeTab: 'stats',
                list: [],
                loading: false,
                saving: false,

                joinList: [],
                statsLoading: false,
                statsColumns: [
                    {
                        title: '序号',
                        width: 60,
                        customRender: (text, record, index) => index + 1
                    },
                    { title: '姓名', dataIndex: 'name' },
                    { title: '组别', dataIndex: 'gp', width: 70 },
                    { title: '报名选项', dataIndex: 'val' },
                    { title: '报名时间', dataIndex: 'create_at', width: 160 }
                ]
            }
        },

        mounted() {
            this.getList();
            this.getJoinList();
        },

        watch: {
            activeTab(val) {
                if (val === 'stats') {
                    this.getJoinList();
                }
            }
        },

        methods: {
            getJoinList() {
                this.statsLoading = true;
                fetchJoinList().then(res => {
                    if (res && Array.isArray(res.list)) {
                        this.joinList = res.list;
                    }
                }).finally(() => {
                    this.statsLoading = false;
                })
            },

            getList(){
                this.loading = true;
                fetchConfig().then(res => {
                    console.log('res',res)
                    if (res && Array.isArray(res.list)) {
                        this.list = res.list.map(item => ({
                            ...item,
                            options: Array.isArray(item.options) ? item.options : []
                        }));
                    }
                }).finally(() => {
                    this.loading = false;
                })
            },

            addActivity() {
                this.list.push({
                    label: '',
                    type: '',
                    open: false,
                    options: []
                });
            },

            removeActivity(index) {
                this.list.splice(index, 1);
            },

            addOption(item) {
                item.options.push({
                    label: '',
                    desc: '',
                    max: 1
                });
            },

            removeOption(item, index) {
                item.options.splice(index, 1);
            },

            validate() {
                for (let i = 0; i < this.list.length; i++) {
                    const item = this.list[i];
                    if (!item.label) {
                        this.$message.error(`第 ${i + 1} 个活动缺少名称`);
                        return false;
                    }
                    if (!item.type) {
                        this.$message.error(`活动「${item.label}」缺少类型标识`);
                        return false;
                    }
                    for (let j = 0; j < item.options.length; j++) {
                        if (!item.options[j].label) {
                            this.$message.error(`活动「${item.label}」的选项 ${j + 1} 缺少标题`);
                            return false;
                        }
                    }
                }
                return true;
            },

            submit() {
                if (!this.validate()) return;

                console.log(this.list)
                this.saving = true;
                const data = new FormData();
                data.append('config', JSON.stringify(this.list))

                setConfig(data).then(res => {
                    console.log('res',res)
                    if (res._status === 1) {
                        this.$message.success(res.info);
                    }
                }).finally(() => {
                    this.saving = false;
                })
            }
        }
    }
</script>


<style scoped>
    .page {
        padding: 16px;
        background-color: #f0f0f0;
        min-height: 100vh;
    }
    .header {
        font-weight: bold;
        font-size: 1.2em;
        margin-bottom: 16px;
    }

    .item {
        background-color: #fff;
        padding: 16px;
        border-radius: 8px;
        margin-bottom: 16px;
    }
    .title {
        font-weight: bold;
        font-size: 1.1em;
        border-bottom: 1px solid #f0f0f0;
        color: #1890ff;
        margin-bottom: 12px;
        padding-bottom: 12px;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .section {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 12px;
    }

    .label {
        font-weight: bold;
        margin-bottom: 4px;
    }

    .field {
        margin-bottom: 12px;
    }

    .field.row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 0;
    }

    .field.row .label {
        margin-bottom: 0;
    }

    .options-label {
        margin-bottom: 8px;
    }

    .option-card {
        border: 1px solid #e8e8e8;
        border-radius: 8px;
        padding: 12px;
        margin-bottom: 12px;
        background-color: #fafafa;
    }

    .option-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 8px;
    }

    .option-index {
        font-weight: bold;
        color: #666;
    }

    .add-activity {
        margin-bottom: 16px;
    }

    .count {
        font-size: 12px;
        color: #999;
        font-weight: normal;
    }
</style>
